import React from 'react';

import ThemeContext from 'components-stateless/Theme/ThemeContext';

const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';

const WithTheme = (WrappedComponent) => {
  const WithThemeHOC = (props) => (
    <ThemeContext.Consumer>
      {(themeConfig) => (
        <WrappedComponent themeConfig={themeConfig} {...props} />
      )}
    </ThemeContext.Consumer>
  );

  WithThemeHOC.displayName = `WithTheme(${getDisplayName(WrappedComponent)})`;

  return WithThemeHOC;
};

export default WithTheme;
